import { AnyEvent } from './ClickOutsideGlobal';

export const isShadowDOMElementContainsTarget = <El extends HTMLElement>(
  el: El,
  event: AnyEvent,
) => event.composedPath().includes(el);
